module.exports = __webpack_public_path__ + "img/TECNOLOGIA-SWIFT-BOOSTER-GREEN-2.9fb62668.jpg";